// extracted by mini-css-extract-plugin
export default {"Terms":"LimitAddOnModal_Terms__H1K7I"};